import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { Subscription as RxJsSubscription } from 'rxjs';
import { ErrorService } from '@app/services';
import { Image } from '../../image';
import { ImageService } from '../../image.service';
import { ActivityLogSearchParams } from '@app/plugins/activity';
@Component({
	selector: 'hpf-image-edit',
	templateUrl: './image-edit.component.html'
})
export class ImageEditComponent implements OnInit, OnDestroy {
	/** The image */
	image = new Image();
	/**	History search params */
	historySearchParams: ActivityLogSearchParams;
	/** The image */
	private id: string;
	/** The id subscription */
	private idSubscription: RxJsSubscription;
	/** Constructor */
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private errorService: ErrorService,
		private imageService: ImageService
	) {}
	/** Init */
	ngOnInit() {
		// Get the image after reading the id
		this.idSubscription = this.route.params.subscribe(params => {
			this.id = params['id'];
			this.refresh();
		});
	}
	/** Destroy */
	ngOnDestroy() {
		this.idSubscription.unsubscribe();
	}
	/** Fetch image from API */
	private refresh() {
		this.imageService
			.get(this.id, { _populate: ['*'] })
			.then((image: Image) => {
				this.image.fromObject(image.toObject());

				// Refresh history
				const params = {
					entity_id: this.id,
					entity_type: 'image',
				};
				if (!this.historySearchParams) {
					this.historySearchParams = new ActivityLogSearchParams(
						params
					);
				} else {
					this.historySearchParams.fromObject(params);
				}
			})
			.catch(error => this.errorService.handle(error));
	}
	/** Called when the image is updated */
	onUpdate(): void {
		this.refresh();
	}
	/** Called when the image is deleted */
	onDelete(): void {
		this.router
			.navigateByUrl('/image')
			.catch(error => this.errorService.handle(error));
	}
}
